import {
  NavigateFunction,
  NavigateOptions,
  To,
  useNavigate,
} from "react-router-dom";

import { checkAuthToken } from "../services/hooks/preauth/checkAuthToken";
import { successfulLoginActions } from "../services/hooks/preauth/useLogin";
import { useAuthStore } from "@/client/services/state/authStore";
import { useEffect } from "react";
import { useHandoffParams } from "../services/hooks/preauth/useHandoffParams";
import { useLocalStorage } from "usehooks-ts";
import { useToastStore } from "../services/state/toastStore";
import { useTranslation } from "react-i18next";

const navigateSamlFactory =
  (navigate: NavigateFunction): NavigateFunction =>
  (to: To | number, options?: NavigateOptions): void => {
    if (window.name === "childsso") {
      window.opener.location.href = to;
      window.close();
      return;
    }
    navigate(to as To, options);
  };

export default function SamlTransition() {
  const { authConfig, setAuthConfig, logout } = useAuthStore();
  const [redirectLocation] = useLocalStorage("redirectLocation", null);
  const [angularRedirectLocation] = useLocalStorage("preRedirect", null);
  const navigate = useNavigate();
  const { setToast } = useToastStore();
  const { t } = useTranslation();
  const params = useHandoffParams();

  useEffect(() => {
    const navigateSamlHelper = navigateSamlFactory(navigate);

    if (
      params.get("authtoken") &&
      params.get("user") &&
      params.get("ttl") &&
      params.get("createdOn")
    ) {
      const tmp = async () => {
        const resultObj = await checkAuthToken(params.get("authtoken")!);
        if (!resultObj.result) {
          setToast({
            show: true,
            status: "error",
            title: t("saml.errors.unknown-origin"),
          });
          navigateSamlHelper("/login");
          return;
        }

        successfulLoginActions(
          resultObj.data,
          authConfig,
          setAuthConfig,
          angularRedirectLocation,
          redirectLocation,
          navigateSamlHelper
        );
      };
      tmp();
    } else {
      logout();
      navigateSamlHelper("/login");
    }
  }, []);
  return <div />;
}
